import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "@/pages/auth/LoginPage";
import { SignupPage } from "@/pages/auth/SignupPage";
import { AuthCompletePage } from "@/pages/auth/AuthCompletePage";
import { DashboardPage } from "@/pages/dashboard/DashboardPage";
import { ConnectionsPage } from "@/pages/connections/ConnectionsPage";
import { RotateKeyPage } from "@/pages/connections/RotateKeyPage";
import { ConnectTwilioPage } from "@/pages/onboarding/ConnectTwilioPage";
import { PhoneNumbersPage } from "@/pages/phone-numbers/PhoneNumbersPage";
import { AcceleratorsPage } from "@/pages/accelerators/AcceleratorsPage";
import { OutboundDialerPage } from "@/pages/dialer/OutboundDialerPage";
import { DialerApiDocsPage } from "@/pages/dialer/DialerApiDocsPage";
import { DialerSettingsPage } from "@/pages/dialer/DialerSettingsPage";
import { WorkspaceSettingsPage } from "@/pages/workspace/WorkspaceSettingsPage";
import { MessagesPage } from "@/pages/messages/MessagesPage";
import { AlertsPage } from "@/pages/error-logs/AlertsPage";
import { AgentFlowIndex } from "@/pages/agentflow/AgentFlowIndex";
import { FlowEditor } from "@/pages/agentflow/FlowEditor";
import { AnalyticsPage } from "@/pages/agentflow/AnalyticsPage";
import { ConversationsListPage } from "@/pages/agentflow/ConversationsListPage";
import { ConversationReplayPage } from "@/pages/agentflow/ConversationReplayPage";
import { PendingAppointmentsPage } from "@/pages/agentflow/PendingAppointmentsPage";
import { KnowledgeBasePage } from "@/pages/agentflow/KnowledgeBasePage";
import { SlotCatalogPage } from "@/pages/agentflow/SlotCatalogPage";
import { DeliverabilityPage } from "@/pages/insights/DeliverabilityPage";
import { HealthPage } from "@/pages/insights/HealthPage";
import { CostPage } from "@/pages/insights/CostPage";
import { EngagementPage } from "@/pages/insights/EngagementPage";
import { RequireAuth } from "@/components/RequireAuth";
import { AppShell } from "@/components/AppShell";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/auth/complete" element={<AuthCompletePage />} />

      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/insights/health" element={<HealthPage />} />
        <Route path="/insights/cost" element={<CostPage />} />
        <Route path="/insights/deliverability" element={<DeliverabilityPage />} />
        <Route path="/insights/engagement" element={<EngagementPage />} />
        <Route path="/phone-numbers" element={<PhoneNumbersPage />} />
        <Route path="/accelerators" element={<AcceleratorsPage />} />
        <Route path="/dialer" element={<OutboundDialerPage />} />
        <Route path="/dialer/api" element={<DialerApiDocsPage />} />
        <Route path="/dialer/settings" element={<DialerSettingsPage />} />
        <Route path="/workspace/settings" element={<WorkspaceSettingsPage />} />
        <Route path="/agentflow" element={<AgentFlowIndex />} />
        <Route path="/agentflow/analytics" element={<AnalyticsPage />} />
        {/* Settings consolidated into Workspace → Settings (all tenant-wide). */}
        <Route path="/agentflow/settings" element={<Navigate to="/workspace/settings" replace />} />
        <Route path="/agentflow/conversations" element={<ConversationsListPage />} />
        <Route path="/agentflow/conversations/:id" element={<ConversationReplayPage />} />
        <Route path="/agentflow/pending-appointments" element={<PendingAppointmentsPage />} />
        <Route path="/agentflow/knowledge-base" element={<KnowledgeBasePage />} />
        <Route path="/agentflow/slots" element={<SlotCatalogPage />} />
        <Route path="/agentflow/flows/:id" element={<FlowEditor />} />
        <Route path="/connections" element={<ConnectionsPage />} />
        <Route path="/connections/new" element={<ConnectTwilioPage />} />
        <Route path="/connections/:id/rotate" element={<RotateKeyPage />} />
        {/* Back-compat: old route used during early dev. */}
        <Route path="/onboarding/twilio" element={<Navigate to="/connections/new" replace />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
